import { useTranslation } from "react-i18next";
import { PageHelmet } from "@/src/common/components/page-helmet";
import { Button } from "@/src/common/components/ui";
import { buildMainAppUrl } from "@/src/common/lib/subdomain";

export default function CommunityNotFoundPage() {
	const { t } = useTranslation("common");

	const handleGoHome = () => {
		window.location.href = buildMainAppUrl("/");
	};

	return (
		<>
			<PageHelmet title={t("community_not_found_title")} />
			<div className="flex min-h-screen items-center justify-center bg-background px-6">
				<div className="flex flex-col items-center text-center max-w-md">
					<p className="text-9xl font-extrabold bg-linear-to-br from-primary to-secondary bg-clip-text text-transparent select-none">404</p>
					<h1 className="mt-4 text-2xl font-semibold text-foreground">{t("community_not_found_title")}</h1>
					<p className="mt-2 text-foreground/50 text-balance">{t("community_not_found_description")}</p>
					<div className="mt-8 flex gap-3">
						<Button variant="primary" onPress={handleGoHome}>
							{t("community_not_found_cta")}
						</Button>
					</div>
				</div>
			</div>
		</>
	);
}
